(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/fractiongames/assets/react/components/reserved-games-message.js') >= 0) return;  svs.modules.push('/components/numbergames/fractiongames/assets/react/components/reserved-games-message.js');

'use strict';

const Icon = svs.ui.ReactIcon;
const ReservedGamesMessage = () => React.createElement("div", {
  className: "ng-fg-reserved-games-message-container"
}, React.createElement(Icon, {
  icon: "help-2"
}), React.createElement("span", {
  className: "ng-fg-reserved-games-message"
}, "Du har reserverade andelsspel.", React.createElement("a", {
  href: svs.core.urlMapping.get('fractiongamesReserved')
}, " Se dina spel h\xE4r.")));
svs.numbergames.fractiongames.components.ReservedGamesMessage = ReservedGamesMessage;

 })(window);